export default __webpack_public_path__ + "static/media/doc-bell_icon.43afed01.svg";